<script setup lang="ts">
import {
  onUnmounted,
  toRef,
} from 'vue';

import { ARTICLES_PERMISSIONS } from '@modules/articles/constants';
import TheDashboardArticles
  from '@modules/dashboard/components/TheDashboardArticles/TheDashboardArticles.vue';
import TheDashboardCharts
  from '@modules/dashboard/components/TheDashboardCharts/TheDashboardCharts.vue';
import TheDashboardChief
  from '@modules/dashboard/components/TheDashboardChief/TheDashboardChief.vue';
import TheDashboardLastUpdate
  from '@modules/dashboard/components/TheDashboardLastUpdate/TheDashboardLastUpdate.vue';
import TheDashboardMerchants from '@modules/dashboard/components/TheDashboardMerchants/TheDashboardMerchants.vue';
import TheDashboardPlayerCheck
  from '@modules/dashboard/components/TheDashboardPlayerCheck/TheDashboardPlayerCheck.vue';
import TheDashboardStatsDisplay
  from '@modules/dashboard/components/TheDashboardStatsDisplay/TheDashboardStatsDisplay.vue';
import TheDashboardTops from '@modules/dashboard/components/TheDashboardTops/TheDashboardTops.vue';
import {
  DASHBOARD_PERMISSIONS,
} from '@modules/dashboard/constants';
import { useDashboardStore } from '@modules/dashboard/store';
import { useCurrentNamespace } from '@modules/permissions/composables';
import { useUserStore } from '@modules/user/store';

const { reset } = useDashboardStore();
const isSupervisionSignOutProcess = toRef(useUserStore(), 'isSupervisionSignOutProcess');
const { isAdminNamespace, isAffiliateNamespace } = useCurrentNamespace();

onUnmounted(reset);
</script>

<template>
  <!-- prevent dashboard rerender on sign out process -->
  <div v-data-qa-auto-id="'DashboardPage'" v-if="!isSupervisionSignOutProcess && $hasPermission(DASHBOARD_PERMISSIONS.DASHBOARD_GET_STATS)">
    <div class="pt-2">
      <div class="mb-2 flex flex-wrap items-center justify-between">
        <span class="mb-4 flex grow items-center justify-center sm:mb-0 sm:grow-0">
          <TheDashboardLastUpdate
            v-if="$hasPermission(DASHBOARD_PERMISSIONS.DASHBOARD_LAST_UPDATE)"
          />
        </span>
        <TheDashboardMerchants v-if="$hasPermission(DASHBOARD_PERMISSIONS.DASHBOARD_GET_STATS)" />
      </div>
      <TheDashboardStatsDisplay
        v-if="$hasPermission(DASHBOARD_PERMISSIONS.DASHBOARD_GET_STATS)"
        class="mb-4 w-full"
      />
      <TheDashboardCharts
        v-if="$hasPermission(DASHBOARD_PERMISSIONS.DASHBOARD_CHART)"
        class="mb-4 w-full"
      />

      <!-- ADMIN -->
      <div v-if="isAdminNamespace">
        <TheDashboardTops
          v-if="$hasPermission(DASHBOARD_PERMISSIONS.DASHBOARD_TOPS)"
          class="mb-4 w-full"
        />
      </div>
      <!-- AFFILIATE -->
      <div v-if="isAffiliateNamespace">
        <TheDashboardArticles
          v-if="$hasPermission(ARTICLES_PERMISSIONS.SHOW)"
          class="mb-4 w-full"
        />
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <TheDashboardChief
            v-if="$hasPermission(DASHBOARD_PERMISSIONS.DASHBOARD_PERSONAL_CHIEF)"
          />
          <TheDashboardPlayerCheck
            v-if="$hasPermission(DASHBOARD_PERMISSIONS.DASHBOARD_PLAYERS_CHECK)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
